import { render, staticRenderFns } from "./systemMessage.vue?vue&type=template&id=3e30925a&scoped=true&"
import script from "./systemMessage.vue?vue&type=script&lang=js&"
export * from "./systemMessage.vue?vue&type=script&lang=js&"
import style0 from "./systemMessage.vue?vue&type=style&index=0&id=3e30925a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e30925a",
  null
  
)

export default component.exports